module.exports = "/images/msg-generic.svg?b67502eed1cac761dcda814e998c392e";